// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen';
import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client/index';
import type { DeleteApiFilesByIdData, DeleteApiFilesByIdResponses, DeleteApiPricetrackerByIdData, DeleteApiPricetrackerByIdResponses, DeleteApiProductentityByIdData, DeleteApiProductentityByIdResponses, DeleteApiProductGroupsByIdData, DeleteApiProductGroupsByIdProductsRemoveByIdsData, DeleteApiProductGroupsByIdProductsRemoveByIdsResponses, DeleteApiProductGroupsByIdProductsRemoveBySkusData, DeleteApiProductGroupsByIdProductsRemoveBySkusResponses, DeleteApiProductGroupsByIdResponses, DeleteApiProductRulesByIdData, DeleteApiProductRulesByIdResponses, DeleteApiRelationsByProductIdData, DeleteApiRelationsByProductIdResponses, DeleteApiSpecificationlabelsByIdData, DeleteApiSpecificationlabelsByIdResponses, DeleteApiSynonymsByIdData, DeleteApiSynonymsByIdResponses, DeleteApiVideosByIdData, DeleteApiVideosByIdResponses, DeleteApiWorktaskByIdData, DeleteApiWorktaskByIdResponses, GetApiBrandsByExternalIdData, GetApiBrandsByExternalIdResponses, GetApiCategoriesByIdData, GetApiCategoriesByIdParentsData, GetApiCategoriesByIdParentsResponses, GetApiCategoriesByIdResponses, GetApiCategoriesData, GetApiCategoriesResponses, GetApiChannelsBySalesChannelIdData, GetApiChannelsBySalesChannelIdResponses, GetApiChannelsData, GetApiChannelsResponses, GetApiExportBrandsData, GetApiExportBrandsResponses, GetApiExportCategoriesData, GetApiExportCategoriesResponses, GetApiExportLabelsData, GetApiExportLabelsResponses, GetApiExportProductsByArticleNumberData, GetApiExportProductsByArticleNumberResponses, GetApiExportProductsData, GetApiExportProductsResponses, GetApiExportVariantsData, GetApiExportVariantsResponses, GetApiFeedsGetfeedByExternalIdentifierByIsoCodeData, GetApiFeedsGetfeedByExternalIdentifierByIsoCodeResponses, GetApiFilesByIdData, GetApiFilesByIdResponses, GetApiFilesData, GetApiFilesResponses, GetApiIntegrationsProductItemsData, GetApiIntegrationsProductItemsNorthmillAccountCodesData, GetApiIntegrationsProductItemsNorthmillAccountCodesResponses, GetApiIntegrationsProductItemsNorthmillBrandsData, GetApiIntegrationsProductItemsNorthmillBrandsResponses, GetApiIntegrationsProductItemsResponses, GetApiJobsByIdData, GetApiJobsByIdResponses, GetApiJobsData, GetApiJobsResponses, GetApiLocaleByIdData, GetApiLocaleByIdResponses, GetApiLocaleData, GetApiLocaleResponses, GetApiMetadataData, GetApiMetadataResponses, GetApiPricetrackerByIdData, GetApiPricetrackerByIdResponses, GetApiPricetrackerData, GetApiPricetrackerIdsData, GetApiPricetrackerIdsResponses, GetApiPricetrackerMetadataData, GetApiPricetrackerMetadataResponses, GetApiPricetrackerResponses, GetApiProductBundlesData, GetApiProductBundlesResponses, GetApiProductentityByIdData, GetApiProductentityByIdResponses, GetApiProductentityData, GetApiProductentityIdsData, GetApiProductentityIdsResponses, GetApiProductentityMetadataData, GetApiProductentityMetadataResponses, GetApiProductentityResponses, GetApiProductGroupsByIdData, GetApiProductGroupsByIdResponses, GetApiProductGroupsByIdWithProductsData, GetApiProductGroupsByIdWithProductsResponses, GetApiProductGroupsPaginatedData, GetApiProductGroupsPaginatedResponses, GetApiProductGroupsProductsBySkusData, GetApiProductGroupsProductsBySkusResponses, GetApiProductitemsByIdData, GetApiProductitemsByIdResponses, GetApiProductitemsData, GetApiProductitemsResponses, GetApiProductRankingsData, GetApiProductRankingsResponses, GetApiProductRulesByIdData, GetApiProductRulesByIdResponses, GetApiProductRulesData, GetApiProductRulesResponses, GetApiProductsByIdData, GetApiProductsByIdResponses, GetApiProductsData, GetApiProductsLookupData, GetApiProductsLookupResponses, GetApiProductsResponses, GetApiPropertiesData, GetApiPropertiesResponses, GetApiResourcesByIdData, GetApiResourcesByIdResponses, GetApiResourcesData, GetApiResourcesResponses, GetApiRolesData, GetApiRolesResponses, GetApiSettingsByIdData, GetApiSettingsByIdResponses, GetApiSettingsData, GetApiSettingsResponses, GetApiSpecificationlabelsByIdData, GetApiSpecificationlabelsByIdProductsData, GetApiSpecificationlabelsByIdProductsResponses, GetApiSpecificationlabelsByIdResponses, GetApiSpecificationlabelsData, GetApiSpecificationlabelsResponses, GetApiSpecificationsByIdData, GetApiSpecificationsByIdResponses, GetApiSynonymsByIdData, GetApiSynonymsByIdResponses, GetApiSynonymsData, GetApiSynonymsResponses, GetApiTenantsByIdData, GetApiTenantsByIdResponses, GetApiTenantsData, GetApiTenantsResponses, GetApiUnitsByIdData, GetApiUnitsByIdResponses, GetApiUnitsData, GetApiUnitsResponses, GetApiUsersByIdData, GetApiUsersByIdResponses, GetApiUsersData, GetApiUsersResponses, GetApiVideosByIdData, GetApiVideosByIdResponses, GetApiVideosData, GetApiVideosResponses, GetApiWorktaskByIdData, GetApiWorktaskByIdResponses, GetApiWorktaskData, GetApiWorktaskIdsData, GetApiWorktaskIdsResponses, GetApiWorktaskMetadataData, GetApiWorktaskMetadataResponses, GetApiWorktaskResponses, GetCsdebugTestCheckifexportableData, GetCsdebugTestCheckifexportableResponses, GetCsdebugTestGeneratetestfeedData, GetCsdebugTestGeneratetestfeedResponses, GetCsdebugTestGetcategorybyidjetshopData, GetCsdebugTestGetcategorybyidjetshopResponses, GetCsdebugTestGetfunctionselectionproductitemsData, GetCsdebugTestGetfunctionselectionproductitemsResponses, GetCsdebugTestGetnorthmillarticleData, GetCsdebugTestGetnorthmillarticleResponses, GetCsdebugTestGetproductbyitemnojetshopData, GetCsdebugTestGetproductbyitemnojetshopResponses, GetCsdebugTestGetproductbyitemnokassanovaData, GetCsdebugTestGetproductbyitemnokassanovaResponses, GetCsdebugTestGetproductsfromjetshopProductsJetshopData, GetCsdebugTestGetproductsfromjetshopProductsJetshopResponses, GetCsdebugTestKassanovaimportitemData, GetCsdebugTestKassanovaimportitemResponses, GetCsdebugTestLookupproductinprisjaktData, GetCsdebugTestLookupproductinprisjaktResponses, GetCsdebugTestTestopenrouterData, GetCsdebugTestTestopenrouterResponses, GetCsdebugTestTriggervoyadoproductfeedData, GetCsdebugTestTriggervoyadoproductfeedResponses, GetCsdebugTestUpdatefromkassanovaData, GetCsdebugTestUpdatefromkassanovaResponses, GetWorkerschedulerWorkerschedulerGetworkersData, GetWorkerschedulerWorkerschedulerGetworkersResponses, GetWorkerschedulerWorkerschedulerGetworkerwitherrorlogsbyidByIdData, GetWorkerschedulerWorkerschedulerGetworkerwitherrorlogsbyidByIdResponses, PatchApiPricetrackerByIdData, PatchApiPricetrackerByIdResponses, PatchApiProductBundlesExportByProductBundleIdData, PatchApiProductBundlesExportByProductBundleIdResponses, PatchApiProductBundlesSyncByProductBundleIdData, PatchApiProductBundlesSyncByProductBundleIdResponses, PatchApiProductBundlesUpdateByProductBundleIdData, PatchApiProductBundlesUpdateByProductBundleIdResponses, PatchApiProductentityByIdData, PatchApiProductentityByIdResponses, PatchApiProductitemsByIdData, PatchApiProductitemsByIdResponses, PatchApiProductsBulkData, PatchApiProductsBulkResponses, PatchApiProductsByIdData, PatchApiProductsByIdResponses, PatchApiProductsByIdSplitData, PatchApiProductsByIdSplitResponses, PatchApiRelationsByProductIdData, PatchApiRelationsByProductIdResponses, PatchApiSettingsByIdData, PatchApiSettingsByIdResponses, PatchApiSpecificationlabelsByIdData, PatchApiSpecificationlabelsByIdResponses, PatchApiSpecificationsByIdData, PatchApiSpecificationsByIdResponses, PatchApiTenantsByIdData, PatchApiTenantsByIdResponses, PatchApiUsersByIdData, PatchApiUsersByIdResponses, PatchApiVideosByIdData, PatchApiVideosByIdResponses, PatchApiWorktaskByIdAddItemsData, PatchApiWorktaskByIdAddItemsResponses, PatchApiWorktaskByIdData, PatchApiWorktaskByIdResponses, PatchCsdebugTestTestupdateData, PatchCsdebugTestTestupdateResponses, PatchWorkerschedulerWorkerschedulerEnableforcenextrunByIdData, PatchWorkerschedulerWorkerschedulerEnableforcenextrunByIdResponses, PostApiActionsAddCategoriesData, PostApiActionsAddCategoriesResponses, PostApiActionsDeleteCategoriesData, PostApiActionsDeleteCategoriesResponses, PostApiActionsKassanovaSynchronizeData, PostApiActionsKassanovaSynchronizeResponses, PostApiActionsTextRewriteData, PostApiActionsTextRewriteResponses, PostApiActionsTranslateData, PostApiActionsTranslateResponses, PostApiActionsUpdateJetshopImagesData, PostApiActionsUpdateJetshopImagesResponses, PostApiBackgroundCalculateImageSizesData, PostApiBackgroundCalculateImageSizesResponses, PostApiBackgroundExportJetshopProductsData, PostApiBackgroundExportJetshopProductsResponses, PostApiBackgroundGetJetshopProductsData, PostApiBackgroundGetJetshopProductsResponses, PostApiBackgroundKassanovaImportArticleNumbersData, PostApiBackgroundKassanovaImportArticleNumbersResponses, PostApiBackgroundPutAmountOnImportQueueData, PostApiBackgroundPutAmountOnImportQueueResponses, PostApiBackgroundResizeImageByIdData, PostApiBackgroundResizeImageByIdResponses, PostApiBackgroundUploadBrandSupplierInfoData, PostApiBackgroundUploadBrandSupplierInfoResponses, PostApiBackgroundValidateProductCategoriesData, PostApiBackgroundValidateProductCategoriesResponses, PostApiBackgroundValidateProductCompletenessData, PostApiBackgroundValidateProductCompletenessResponses, PostApiBackgroundValidateProductUrlsData, PostApiBackgroundValidateProductUrlsResponses, PostApiFilesData, PostApiFilesResponses, PostApiImportChunkFileUploadData, PostApiImportChunkFileUploadResponses, PostApiImportFileUploadData, PostApiImportFileUploadResponses, PostApiIntegrationsProductItemsNorthmillItemsData, PostApiIntegrationsProductItemsNorthmillItemsResponses, PostApiIntegrationsProductItemsQueryData, PostApiIntegrationsProductItemsQueryResponses, PostApiLoginData, PostApiLoginResponses, PostApiPricetrackerBatchImportData, PostApiPricetrackerBatchImportResponses, PostApiPricetrackerData, PostApiPricetrackerResponses, PostApiProductBundlesSyncByArticleNumberData, PostApiProductBundlesSyncByArticleNumberResponses, PostApiProductentityData, PostApiProductentityResponses, PostApiProductGroupsByIdProductsAssignByIdsData, PostApiProductGroupsByIdProductsAssignByIdsResponses, PostApiProductGroupsByIdProductsAssignBySkusData, PostApiProductGroupsByIdProductsAssignBySkusResponses, PostApiProductGroupsData, PostApiProductGroupsResponses, PostApiProductitemsData, PostApiProductitemsResponses, PostApiProductRulesData, PostApiProductRulesResponses, PostApiRegisterData, PostApiRegisterResponses, PostApiRelationsData, PostApiRelationsResponses, PostApiRolesCreateData, PostApiRolesCreateResponses, PostApiSpecificationlabelsData, PostApiSpecificationlabelsResponses, PostApiSynonymsData, PostApiSynonymsResponses, PostApiTenantsData, PostApiTenantsResponses, PostApiUnitsData, PostApiUnitsResponses, PostApiVideosData, PostApiVideosResponses, PostApiWorktaskData, PostApiWorktaskResponses, PostCsdebugTestCreatestockwatchlistStockWatchlistData, PostCsdebugTestCreatestockwatchlistStockWatchlistResponses, PostCsdebugTestProductintegrationsyncProductIntegrationSyncData, PostCsdebugTestProductintegrationsyncProductIntegrationSyncResponses, PostCsdebugTestSendimportmessagetovectoryData, PostCsdebugTestSendimportmessagetovectoryResponses, PostCsdebugTestTestcreateData, PostCsdebugTestTestcreateResponses, PostCsdebugTestUpdatejetshopproductcustomfieldProductsJetshopCustomFieldsData, PostCsdebugTestUpdatejetshopproductcustomfieldProductsJetshopCustomFieldsResponses, PostCsdebugTestUpdatejetshopproductstockstatusbatchProductsJetshopStockStatusBatchData, PostCsdebugTestUpdatejetshopproductstockstatusbatchProductsJetshopStockStatusBatchResponses, PostCsdebugTestUpdatejetshopproductstockstatusData, PostCsdebugTestUpdatejetshopproductstockstatusResponses, PostCsdebugTestVectoryexportbrandsData, PostCsdebugTestVectoryexportbrandsResponses, PostCsdebugTestVectoryexportcategoriesData, PostCsdebugTestVectoryexportcategoriesResponses, PostCsdebugTestVectoryexportproductbundlesData, PostCsdebugTestVectoryexportproductbundlesResponses, PostCsdebugTestVectoryexportspecificproductsData, PostCsdebugTestVectoryexportspecificproductsResponses, PutApiBackgroundSyncVectoryProductsData, PutApiBackgroundSyncVectoryProductsResponses, PutApiBrandsByExternalIdData, PutApiBrandsByExternalIdResponses, PutApiChangePasswordData, PutApiChangePasswordResponses, PutApiChangeTenantData, PutApiChangeTenantResponses, PutApiCheckTokenData, PutApiCheckTokenResponses, PutApiIntegrationsProductItemsEnableSyncData, PutApiIntegrationsProductItemsEnableSyncResponses, PutApiIntegrationsProductItemsPauseData, PutApiIntegrationsProductItemsPauseResponses, PutApiIntegrationsProductItemsUnlockData, PutApiIntegrationsProductItemsUnlockResponses, PutApiPricetrackerBatchSynchronizeData, PutApiPricetrackerBatchSynchronizeResponses, PutApiProductGroupsByIdData, PutApiProductGroupsByIdResponses, PutApiProductRulesByIdData, PutApiProductRulesByIdResponses, PutApiProductRulesRecalculateData, PutApiProductRulesRecalculateResponses, PutApiSynonymsByIdData, PutApiSynonymsByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postApiActionsTextRewrite = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsTextRewriteData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsTextRewriteResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/text-rewrite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiActionsKassanovaSynchronize = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsKassanovaSynchronizeData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsKassanovaSynchronizeResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/kassanova-synchronize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiActionsUpdateJetshopImages = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsUpdateJetshopImagesData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsUpdateJetshopImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/update-jetshop-images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiActionsTranslate = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsTranslateData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsTranslateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiActionsAddCategories = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsAddCategoriesData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsAddCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/add-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiActionsDeleteCategories = <ThrowOnError extends boolean = false>(options?: Options<PostApiActionsDeleteCategoriesData, ThrowOnError>) => (options?.client ?? client).post<PostApiActionsDeleteCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/actions/delete-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiLoginResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiRegister = <ThrowOnError extends boolean = false>(options?: Options<PostApiRegisterData, ThrowOnError>) => (options?.client ?? client).post<PostApiRegisterResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiChangeTenant = <ThrowOnError extends boolean = false>(options?: Options<PutApiChangeTenantData, ThrowOnError>) => (options?.client ?? client).put<PutApiChangeTenantResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/change-tenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiChangePassword = <ThrowOnError extends boolean = false>(options?: Options<PutApiChangePasswordData, ThrowOnError>) => (options?.client ?? client).put<PutApiChangePasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiCheckToken = <ThrowOnError extends boolean = false>(options?: Options<PutApiCheckTokenData, ThrowOnError>) => (options?.client ?? client).put<PutApiCheckTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/check-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiBrandsByExternalId = <ThrowOnError extends boolean = false>(options: Options<GetApiBrandsByExternalIdData, ThrowOnError>) => (options.client ?? client).get<GetApiBrandsByExternalIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/brands/{externalId}',
    ...options
});

export const putApiBrandsByExternalId = <ThrowOnError extends boolean = false>(options: Options<PutApiBrandsByExternalIdData, ThrowOnError>) => (options.client ?? client).put<PutApiBrandsByExternalIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/brands/{externalId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiCategoriesById = <ThrowOnError extends boolean = false>(options: Options<GetApiCategoriesByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiCategoriesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/categories/{id}',
    ...options
});

export const getApiCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/categories',
    ...options
});

export const getApiCategoriesByIdParents = <ThrowOnError extends boolean = false>(options: Options<GetApiCategoriesByIdParentsData, ThrowOnError>) => (options.client ?? client).get<GetApiCategoriesByIdParentsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/categories/{id}/parents',
    ...options
});

export const getApiExportCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiExportCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiExportCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/categories',
    ...options
});

export const getApiExportBrands = <ThrowOnError extends boolean = false>(options?: Options<GetApiExportBrandsData, ThrowOnError>) => (options?.client ?? client).get<GetApiExportBrandsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/brands',
    ...options
});

export const getApiExportProducts = <ThrowOnError extends boolean = false>(options?: Options<GetApiExportProductsData, ThrowOnError>) => (options?.client ?? client).get<GetApiExportProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/products',
    ...options
});

export const getApiExportProductsByArticleNumber = <ThrowOnError extends boolean = false>(options: Options<GetApiExportProductsByArticleNumberData, ThrowOnError>) => (options.client ?? client).get<GetApiExportProductsByArticleNumberResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/products/{articleNumber}',
    ...options
});

export const getApiExportVariants = <ThrowOnError extends boolean = false>(options?: Options<GetApiExportVariantsData, ThrowOnError>) => (options?.client ?? client).get<GetApiExportVariantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/variants',
    ...options
});

export const getApiExportLabels = <ThrowOnError extends boolean = false>(options?: Options<GetApiExportLabelsData, ThrowOnError>) => (options?.client ?? client).get<GetApiExportLabelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/export/labels',
    ...options
});

export const getApiFeedsGetfeedByExternalIdentifierByIsoCode = <ThrowOnError extends boolean = false>(options: Options<GetApiFeedsGetfeedByExternalIdentifierByIsoCodeData, ThrowOnError>) => (options.client ?? client).get<GetApiFeedsGetfeedByExternalIdentifierByIsoCodeResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/feeds/getfeed/{externalIdentifier}/{isoCode}',
    ...options
});

export const deleteApiFilesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiFilesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiFilesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/files/{id}',
    ...options
});

export const getApiFilesById = <ThrowOnError extends boolean = false>(options: Options<GetApiFilesByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiFilesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/files/{id}',
    ...options
});

export const getApiFiles = <ThrowOnError extends boolean = false>(options?: Options<GetApiFilesData, ThrowOnError>) => (options?.client ?? client).get<GetApiFilesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/files',
    ...options
});

export const postApiFiles = <ThrowOnError extends boolean = false>(options?: Options<PostApiFilesData, ThrowOnError>) => (options?.client ?? client).post<PostApiFilesResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/files',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const postApiImportFileUpload = <ThrowOnError extends boolean = false>(options?: Options<PostApiImportFileUploadData, ThrowOnError>) => (options?.client ?? client).post<PostApiImportFileUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/import/file-upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const postApiImportChunkFileUpload = <ThrowOnError extends boolean = false>(options?: Options<PostApiImportChunkFileUploadData, ThrowOnError>) => (options?.client ?? client).post<PostApiImportChunkFileUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/import/chunk-file-upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const postApiBackgroundGetJetshopProducts = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundGetJetshopProductsData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundGetJetshopProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/get-jetshop-products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiBackgroundKassanovaImportArticleNumbers = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundKassanovaImportArticleNumbersData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundKassanovaImportArticleNumbersResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/kassanova-import-article-numbers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiBackgroundExportJetshopProducts = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundExportJetshopProductsData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundExportJetshopProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/export-jetshop-products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiBackgroundPutAmountOnImportQueue = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundPutAmountOnImportQueueData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundPutAmountOnImportQueueResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/put-amount-on-import-queue',
    ...options
});

export const postApiBackgroundCalculateImageSizes = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundCalculateImageSizesData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundCalculateImageSizesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/calculate-image-sizes',
    ...options
});

export const postApiBackgroundResizeImageById = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundResizeImageByIdData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundResizeImageByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/resize-image-by-id',
    ...options
});

export const postApiBackgroundValidateProductCategories = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundValidateProductCategoriesData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundValidateProductCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/validate-product-categories',
    ...options
});

export const postApiBackgroundValidateProductUrls = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundValidateProductUrlsData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundValidateProductUrlsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/validate-product-urls',
    ...options
});

export const postApiBackgroundValidateProductCompleteness = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundValidateProductCompletenessData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundValidateProductCompletenessResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/validate-product-completeness',
    ...options
});

export const putApiBackgroundSyncVectoryProducts = <ThrowOnError extends boolean = false>(options?: Options<PutApiBackgroundSyncVectoryProductsData, ThrowOnError>) => (options?.client ?? client).put<PutApiBackgroundSyncVectoryProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/sync-vectory-products',
    ...options
});

export const postApiBackgroundUploadBrandSupplierInfo = <ThrowOnError extends boolean = false>(options?: Options<PostApiBackgroundUploadBrandSupplierInfoData, ThrowOnError>) => (options?.client ?? client).post<PostApiBackgroundUploadBrandSupplierInfoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/background/upload-brand-supplier-info',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const getApiJobsById = <ThrowOnError extends boolean = false>(options: Options<GetApiJobsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiJobsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/jobs/{id}',
    ...options
});

export const getApiJobs = <ThrowOnError extends boolean = false>(options?: Options<GetApiJobsData, ThrowOnError>) => (options?.client ?? client).get<GetApiJobsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/jobs',
    ...options
});

export const getApiLocaleById = <ThrowOnError extends boolean = false>(options: Options<GetApiLocaleByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiLocaleByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/locale/{id}',
    ...options
});

export const getApiLocale = <ThrowOnError extends boolean = false>(options?: Options<GetApiLocaleData, ThrowOnError>) => (options?.client ?? client).get<GetApiLocaleResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/locale',
    ...options
});

export const getApiMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetApiMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetApiMetadataResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/metadata',
    ...options
});

export const postApiPricetrackerBatchImport = <ThrowOnError extends boolean = false>(options?: Options<PostApiPricetrackerBatchImportData, ThrowOnError>) => (options?.client ?? client).post<PostApiPricetrackerBatchImportResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/batch-import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiPricetrackerBatchSynchronize = <ThrowOnError extends boolean = false>(options?: Options<PutApiPricetrackerBatchSynchronizeData, ThrowOnError>) => (options?.client ?? client).put<PutApiPricetrackerBatchSynchronizeResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/batch-synchronize',
    ...options
});

export const deleteApiPricetrackerById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPricetrackerByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiPricetrackerByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/{id}',
    ...options
});

export const getApiPricetrackerById = <ThrowOnError extends boolean = false>(options: Options<GetApiPricetrackerByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiPricetrackerByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/{id}',
    ...options
});

export const patchApiPricetrackerById = <ThrowOnError extends boolean = false>(options: Options<PatchApiPricetrackerByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiPricetrackerByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiPricetrackerIds = <ThrowOnError extends boolean = false>(options?: Options<GetApiPricetrackerIdsData, ThrowOnError>) => (options?.client ?? client).get<GetApiPricetrackerIdsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/ids',
    ...options
});

export const getApiPricetracker = <ThrowOnError extends boolean = false>(options?: Options<GetApiPricetrackerData, ThrowOnError>) => (options?.client ?? client).get<GetApiPricetrackerResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker',
    ...options
});

export const postApiPricetracker = <ThrowOnError extends boolean = false>(options?: Options<PostApiPricetrackerData, ThrowOnError>) => (options?.client ?? client).post<PostApiPricetrackerResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiPricetrackerMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetApiPricetrackerMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetApiPricetrackerMetadataResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/pricetracker/metadata',
    ...options
});

export const getApiProductsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProductsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiProductsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products/{id}',
    ...options
});

export const patchApiProductsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProducts = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products',
    ...options
});

export const patchApiProductsBulk = <ThrowOnError extends boolean = false>(options?: Options<PatchApiProductsBulkData, ThrowOnError>) => (options?.client ?? client).patch<PatchApiProductsBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const patchApiProductsByIdSplit = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductsByIdSplitData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductsByIdSplitResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products/{id}/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductsLookup = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductsLookupData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductsLookupResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/products/lookup',
    ...options
});

export const getApiProductBundles = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductBundlesData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductBundlesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-bundles',
    ...options
});

export const postApiProductBundlesSyncByArticleNumber = <ThrowOnError extends boolean = false>(options: Options<PostApiProductBundlesSyncByArticleNumberData, ThrowOnError>) => (options.client ?? client).post<PostApiProductBundlesSyncByArticleNumberResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-bundles/sync/{articleNumber}',
    ...options
});

export const patchApiProductBundlesSyncByProductBundleId = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductBundlesSyncByProductBundleIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductBundlesSyncByProductBundleIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-bundles/sync/{productBundleId}',
    ...options
});

export const patchApiProductBundlesUpdateByProductBundleId = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductBundlesUpdateByProductBundleIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductBundlesUpdateByProductBundleIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-bundles/update/{productBundleId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchApiProductBundlesExportByProductBundleId = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductBundlesExportByProductBundleIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductBundlesExportByProductBundleIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-bundles/export/{productBundleId}',
    ...options
});

export const deleteApiProductentityById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiProductentityByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiProductentityByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity/{id}',
    ...options
});

export const getApiProductentityById = <ThrowOnError extends boolean = false>(options: Options<GetApiProductentityByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiProductentityByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity/{id}',
    ...options
});

export const patchApiProductentityById = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductentityByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductentityByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductentityIds = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductentityIdsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductentityIdsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity/ids',
    ...options
});

export const getApiProductentity = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductentityData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductentityResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity',
    ...options
});

export const postApiProductentity = <ThrowOnError extends boolean = false>(options?: Options<PostApiProductentityData, ThrowOnError>) => (options?.client ?? client).post<PostApiProductentityResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiProductentityMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductentityMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductentityMetadataResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productentity/metadata',
    ...options
});

export const getApiProductGroupsPaginated = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductGroupsPaginatedData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductGroupsPaginatedResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/paginated',
    ...options
});

export const deleteApiProductGroupsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiProductGroupsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiProductGroupsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}',
    ...options
});

export const getApiProductGroupsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProductGroupsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiProductGroupsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}',
    ...options
});

export const putApiProductGroupsById = <ThrowOnError extends boolean = false>(options: Options<PutApiProductGroupsByIdData, ThrowOnError>) => (options.client ?? client).put<PutApiProductGroupsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductGroupsByIdWithProducts = <ThrowOnError extends boolean = false>(options: Options<GetApiProductGroupsByIdWithProductsData, ThrowOnError>) => (options.client ?? client).get<GetApiProductGroupsByIdWithProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}/with-products',
    ...options
});

export const postApiProductGroups = <ThrowOnError extends boolean = false>(options?: Options<PostApiProductGroupsData, ThrowOnError>) => (options?.client ?? client).post<PostApiProductGroupsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiProductGroupsByIdProductsAssignBySkus = <ThrowOnError extends boolean = false>(options: Options<PostApiProductGroupsByIdProductsAssignBySkusData, ThrowOnError>) => (options.client ?? client).post<PostApiProductGroupsByIdProductsAssignBySkusResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}/products/assign-by-skus',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiProductGroupsByIdProductsAssignByIds = <ThrowOnError extends boolean = false>(options: Options<PostApiProductGroupsByIdProductsAssignByIdsData, ThrowOnError>) => (options.client ?? client).post<PostApiProductGroupsByIdProductsAssignByIdsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}/products/assign-by-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiProductGroupsByIdProductsRemoveBySkus = <ThrowOnError extends boolean = false>(options: Options<DeleteApiProductGroupsByIdProductsRemoveBySkusData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiProductGroupsByIdProductsRemoveBySkusResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}/products/remove-by-skus',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiProductGroupsByIdProductsRemoveByIds = <ThrowOnError extends boolean = false>(options: Options<DeleteApiProductGroupsByIdProductsRemoveByIdsData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiProductGroupsByIdProductsRemoveByIdsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/{id}/products/remove-by-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductGroupsProductsBySkus = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductGroupsProductsBySkusData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductGroupsProductsBySkusResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-groups/products/by-skus',
    ...options
});

export const getApiProductitemsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProductitemsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiProductitemsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productitems/{id}',
    ...options
});

export const patchApiProductitemsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiProductitemsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiProductitemsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productitems/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductitems = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductitemsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductitemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productitems',
    ...options
});

export const postApiProductitems = <ThrowOnError extends boolean = false>(options?: Options<PostApiProductitemsData, ThrowOnError>) => (options?.client ?? client).post<PostApiProductitemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/productitems',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiIntegrationsProductItems = <ThrowOnError extends boolean = false>(options?: Options<GetApiIntegrationsProductItemsData, ThrowOnError>) => (options?.client ?? client).get<GetApiIntegrationsProductItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items',
    ...options
});

export const postApiIntegrationsProductItemsQuery = <ThrowOnError extends boolean = false>(options?: Options<PostApiIntegrationsProductItemsQueryData, ThrowOnError>) => (options?.client ?? client).post<PostApiIntegrationsProductItemsQueryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiIntegrationsProductItemsUnlock = <ThrowOnError extends boolean = false>(options?: Options<PutApiIntegrationsProductItemsUnlockData, ThrowOnError>) => (options?.client ?? client).put<PutApiIntegrationsProductItemsUnlockResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/unlock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiIntegrationsProductItemsPause = <ThrowOnError extends boolean = false>(options?: Options<PutApiIntegrationsProductItemsPauseData, ThrowOnError>) => (options?.client ?? client).put<PutApiIntegrationsProductItemsPauseResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiIntegrationsProductItemsEnableSync = <ThrowOnError extends boolean = false>(options?: Options<PutApiIntegrationsProductItemsEnableSyncData, ThrowOnError>) => (options?.client ?? client).put<PutApiIntegrationsProductItemsEnableSyncResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/enable-sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiIntegrationsProductItemsNorthmillBrands = <ThrowOnError extends boolean = false>(options?: Options<GetApiIntegrationsProductItemsNorthmillBrandsData, ThrowOnError>) => (options?.client ?? client).get<GetApiIntegrationsProductItemsNorthmillBrandsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/northmill/brands',
    ...options
});

export const getApiIntegrationsProductItemsNorthmillAccountCodes = <ThrowOnError extends boolean = false>(options?: Options<GetApiIntegrationsProductItemsNorthmillAccountCodesData, ThrowOnError>) => (options?.client ?? client).get<GetApiIntegrationsProductItemsNorthmillAccountCodesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/northmill/account-codes',
    ...options
});

export const postApiIntegrationsProductItemsNorthmillItems = <ThrowOnError extends boolean = false>(options?: Options<PostApiIntegrationsProductItemsNorthmillItemsData, ThrowOnError>) => (options?.client ?? client).post<PostApiIntegrationsProductItemsNorthmillItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/integrations/product-items/northmill/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiProductRulesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiProductRulesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiProductRulesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules/{id}',
    ...options
});

export const getApiProductRulesById = <ThrowOnError extends boolean = false>(options: Options<GetApiProductRulesByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiProductRulesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules/{id}',
    ...options
});

export const putApiProductRulesById = <ThrowOnError extends boolean = false>(options: Options<PutApiProductRulesByIdData, ThrowOnError>) => (options.client ?? client).put<PutApiProductRulesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiProductRules = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductRulesData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductRulesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules',
    ...options
});

export const postApiProductRules = <ThrowOnError extends boolean = false>(options?: Options<PostApiProductRulesData, ThrowOnError>) => (options?.client ?? client).post<PostApiProductRulesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiProductRulesRecalculate = <ThrowOnError extends boolean = false>(options?: Options<PutApiProductRulesRecalculateData, ThrowOnError>) => (options?.client ?? client).put<PutApiProductRulesRecalculateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product-rules/recalculate',
    ...options
});

export const getApiProductRankings = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductRankingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductRankingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/product/rankings',
    ...options
});

export const getApiProperties = <ThrowOnError extends boolean = false>(options?: Options<GetApiPropertiesData, ThrowOnError>) => (options?.client ?? client).get<GetApiPropertiesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/properties',
    ...options
});

export const postApiRelations = <ThrowOnError extends boolean = false>(options?: Options<PostApiRelationsData, ThrowOnError>) => (options?.client ?? client).post<PostApiRelationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/relations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiRelationsByProductId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiRelationsByProductIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiRelationsByProductIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/relations/{productId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchApiRelationsByProductId = <ThrowOnError extends boolean = false>(options: Options<PatchApiRelationsByProductIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiRelationsByProductIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/relations/{productId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiResourcesById = <ThrowOnError extends boolean = false>(options: Options<GetApiResourcesByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiResourcesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/resources/{id}',
    ...options
});

export const getApiResources = <ThrowOnError extends boolean = false>(options?: Options<GetApiResourcesData, ThrowOnError>) => (options?.client ?? client).get<GetApiResourcesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/resources',
    ...options
});

export const getApiRoles = <ThrowOnError extends boolean = false>(options?: Options<GetApiRolesData, ThrowOnError>) => (options?.client ?? client).get<GetApiRolesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/roles',
    ...options
});

export const postApiRolesCreate = <ThrowOnError extends boolean = false>(options?: Options<PostApiRolesCreateData, ThrowOnError>) => (options?.client ?? client).post<PostApiRolesCreateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/roles/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiChannels = <ThrowOnError extends boolean = false>(options?: Options<GetApiChannelsData, ThrowOnError>) => (options?.client ?? client).get<GetApiChannelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/channels',
    ...options
});

export const getApiChannelsBySalesChannelId = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsBySalesChannelIdData, ThrowOnError>) => (options.client ?? client).get<GetApiChannelsBySalesChannelIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/channels/{salesChannelId}',
    ...options
});

export const getApiSettingsById = <ThrowOnError extends boolean = false>(options: Options<GetApiSettingsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiSettingsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/settings/{id}',
    ...options
});

export const patchApiSettingsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiSettingsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiSettingsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiSettingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/settings',
    ...options
});

export const getApiSpecificationsById = <ThrowOnError extends boolean = false>(options: Options<GetApiSpecificationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiSpecificationsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specifications/{id}',
    ...options
});

export const patchApiSpecificationsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiSpecificationsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiSpecificationsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specifications/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiSpecificationlabelsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiSpecificationlabelsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiSpecificationlabelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels/{id}',
    ...options
});

export const getApiSpecificationlabelsById = <ThrowOnError extends boolean = false>(options: Options<GetApiSpecificationlabelsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiSpecificationlabelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels/{id}',
    ...options
});

export const patchApiSpecificationlabelsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiSpecificationlabelsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiSpecificationlabelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiSpecificationlabels = <ThrowOnError extends boolean = false>(options?: Options<GetApiSpecificationlabelsData, ThrowOnError>) => (options?.client ?? client).get<GetApiSpecificationlabelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels',
    ...options
});

export const postApiSpecificationlabels = <ThrowOnError extends boolean = false>(options?: Options<PostApiSpecificationlabelsData, ThrowOnError>) => (options?.client ?? client).post<PostApiSpecificationlabelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiSpecificationlabelsByIdProducts = <ThrowOnError extends boolean = false>(options: Options<GetApiSpecificationlabelsByIdProductsData, ThrowOnError>) => (options.client ?? client).get<GetApiSpecificationlabelsByIdProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/specificationlabels/{id}/products',
    ...options
});

export const deleteApiSynonymsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiSynonymsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiSynonymsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/synonyms/{id}',
    ...options
});

export const getApiSynonymsById = <ThrowOnError extends boolean = false>(options: Options<GetApiSynonymsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiSynonymsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/synonyms/{id}',
    ...options
});

export const putApiSynonymsById = <ThrowOnError extends boolean = false>(options: Options<PutApiSynonymsByIdData, ThrowOnError>) => (options.client ?? client).put<PutApiSynonymsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/synonyms/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiSynonyms = <ThrowOnError extends boolean = false>(options?: Options<GetApiSynonymsData, ThrowOnError>) => (options?.client ?? client).get<GetApiSynonymsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/synonyms',
    ...options
});

export const postApiSynonyms = <ThrowOnError extends boolean = false>(options?: Options<PostApiSynonymsData, ThrowOnError>) => (options?.client ?? client).post<PostApiSynonymsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/synonyms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiTenantsById = <ThrowOnError extends boolean = false>(options: Options<GetApiTenantsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiTenantsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/tenants/{id}',
    ...options
});

export const patchApiTenantsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiTenantsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiTenantsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/tenants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiTenants = <ThrowOnError extends boolean = false>(options?: Options<GetApiTenantsData, ThrowOnError>) => (options?.client ?? client).get<GetApiTenantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/tenants',
    ...options
});

export const postApiTenants = <ThrowOnError extends boolean = false>(options?: Options<PostApiTenantsData, ThrowOnError>) => (options?.client ?? client).post<PostApiTenantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getCsdebugTestTriggervoyadoproductfeed = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestTriggervoyadoproductfeedData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestTriggervoyadoproductfeedResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/triggervoyadoproductfeed',
    ...options
});

export const getCsdebugTestUpdatefromkassanova = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestUpdatefromkassanovaData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestUpdatefromkassanovaResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/updatefromkassanova',
    ...options
});

export const getCsdebugTestLookupproductinprisjakt = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestLookupproductinprisjaktData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestLookupproductinprisjaktResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/lookupproductinprisjakt',
    ...options
});

export const getCsdebugTestGetproductbyitemnokassanova = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetproductbyitemnokassanovaData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetproductbyitemnokassanovaResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getproductbyitemnokassanova',
    ...options
});

export const getCsdebugTestKassanovaimportitem = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestKassanovaimportitemData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestKassanovaimportitemResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/kassanovaimportitem',
    ...options
});

export const patchCsdebugTestTestupdate = <ThrowOnError extends boolean = false>(options?: Options<PatchCsdebugTestTestupdateData, ThrowOnError>) => (options?.client ?? client).patch<PatchCsdebugTestTestupdateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/testupdate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postCsdebugTestTestcreate = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestTestcreateData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestTestcreateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/testcreate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postCsdebugTestSendimportmessagetovectory = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestSendimportmessagetovectoryData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestSendimportmessagetovectoryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/sendimportmessagetovectory',
    ...options
});

export const postCsdebugTestVectoryexportspecificproducts = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestVectoryexportspecificproductsData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestVectoryexportspecificproductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/vectoryexportspecificproducts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postCsdebugTestVectoryexportbrands = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestVectoryexportbrandsData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestVectoryexportbrandsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/vectoryexportbrands',
    ...options
});

export const postCsdebugTestVectoryexportcategories = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestVectoryexportcategoriesData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestVectoryexportcategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/vectoryexportcategories',
    ...options
});

export const postCsdebugTestVectoryexportproductbundles = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestVectoryexportproductbundlesData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestVectoryexportproductbundlesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/vectoryexportproductbundles',
    ...options
});

export const getCsdebugTestGetproductbyitemnojetshop = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetproductbyitemnojetshopData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetproductbyitemnojetshopResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getproductbyitemnojetshop',
    ...options
});

export const getCsdebugTestGetcategorybyidjetshop = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetcategorybyidjetshopData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetcategorybyidjetshopResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getcategorybyidjetshop',
    ...options
});

export const getCsdebugTestGetproductsfromjetshopProductsJetshop = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetproductsfromjetshopProductsJetshopData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetproductsfromjetshopProductsJetshopResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getproductsfromjetshop/products/jetshop',
    ...options
});

export const getCsdebugTestGeneratetestfeed = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGeneratetestfeedData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGeneratetestfeedResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/generatetestfeed',
    ...options
});

export const getCsdebugTestCheckifexportable = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestCheckifexportableData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestCheckifexportableResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/checkifexportable',
    ...options
});

export const getCsdebugTestTestopenrouter = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestTestopenrouterData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestTestopenrouterResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/testopenrouter',
    ...options
});

export const getCsdebugTestGetfunctionselectionproductitems = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetfunctionselectionproductitemsData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetfunctionselectionproductitemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getfunctionselectionproductitems',
    ...options
});

export const postCsdebugTestUpdatejetshopproductstockstatus = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestUpdatejetshopproductstockstatusData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestUpdatejetshopproductstockstatusResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/updatejetshopproductstockstatus',
    ...options
});

export const postCsdebugTestUpdatejetshopproductstockstatusbatchProductsJetshopStockStatusBatch = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestUpdatejetshopproductstockstatusbatchProductsJetshopStockStatusBatchData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestUpdatejetshopproductstockstatusbatchProductsJetshopStockStatusBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/updatejetshopproductstockstatusbatch/products/jetshop/stock-status/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postCsdebugTestUpdatejetshopproductcustomfieldProductsJetshopCustomFields = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestUpdatejetshopproductcustomfieldProductsJetshopCustomFieldsData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestUpdatejetshopproductcustomfieldProductsJetshopCustomFieldsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/updatejetshopproductcustomfield/products/jetshop/custom-fields',
    ...options
});

export const postCsdebugTestCreatestockwatchlistStockWatchlist = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestCreatestockwatchlistStockWatchlistData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestCreatestockwatchlistStockWatchlistResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/createstockwatchlist/stock-watchlist',
    ...options
});

export const getCsdebugTestGetnorthmillarticle = <ThrowOnError extends boolean = false>(options?: Options<GetCsdebugTestGetnorthmillarticleData, ThrowOnError>) => (options?.client ?? client).get<GetCsdebugTestGetnorthmillarticleResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/getnorthmillarticle',
    ...options
});

export const postCsdebugTestProductintegrationsyncProductIntegrationSync = <ThrowOnError extends boolean = false>(options?: Options<PostCsdebugTestProductintegrationsyncProductIntegrationSyncData, ThrowOnError>) => (options?.client ?? client).post<PostCsdebugTestProductintegrationsyncProductIntegrationSyncResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/csdebug/test/productintegrationsync/product-integration-sync',
    ...options
});

export const getApiUnitsById = <ThrowOnError extends boolean = false>(options: Options<GetApiUnitsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiUnitsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/units/{id}',
    ...options
});

export const getApiUnits = <ThrowOnError extends boolean = false>(options?: Options<GetApiUnitsData, ThrowOnError>) => (options?.client ?? client).get<GetApiUnitsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/units',
    ...options
});

export const postApiUnits = <ThrowOnError extends boolean = false>(options?: Options<PostApiUnitsData, ThrowOnError>) => (options?.client ?? client).post<PostApiUnitsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/units',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiUsersById = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/users/{id}',
    ...options
});

export const patchApiUsersById = <ThrowOnError extends boolean = false>(options: Options<PatchApiUsersByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiUsers = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiUsersResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/users',
    ...options
});

export const deleteApiVideosById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiVideosByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiVideosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/videos/{id}',
    ...options
});

export const getApiVideosById = <ThrowOnError extends boolean = false>(options: Options<GetApiVideosByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiVideosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/videos/{id}',
    ...options
});

export const patchApiVideosById = <ThrowOnError extends boolean = false>(options: Options<PatchApiVideosByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiVideosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/videos/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiVideos = <ThrowOnError extends boolean = false>(options?: Options<GetApiVideosData, ThrowOnError>) => (options?.client ?? client).get<GetApiVideosResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/videos',
    ...options
});

export const postApiVideos = <ThrowOnError extends boolean = false>(options?: Options<PostApiVideosData, ThrowOnError>) => (options?.client ?? client).post<PostApiVideosResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/videos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const patchApiWorktaskByIdAddItems = <ThrowOnError extends boolean = false>(options: Options<PatchApiWorktaskByIdAddItemsData, ThrowOnError>) => (options.client ?? client).patch<PatchApiWorktaskByIdAddItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/{id}/add-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiWorktaskById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiWorktaskByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiWorktaskByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/{id}',
    ...options
});

export const getApiWorktaskById = <ThrowOnError extends boolean = false>(options: Options<GetApiWorktaskByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiWorktaskByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/{id}',
    ...options
});

export const patchApiWorktaskById = <ThrowOnError extends boolean = false>(options: Options<PatchApiWorktaskByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiWorktaskByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiWorktaskIds = <ThrowOnError extends boolean = false>(options?: Options<GetApiWorktaskIdsData, ThrowOnError>) => (options?.client ?? client).get<GetApiWorktaskIdsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/ids',
    ...options
});

export const getApiWorktask = <ThrowOnError extends boolean = false>(options?: Options<GetApiWorktaskData, ThrowOnError>) => (options?.client ?? client).get<GetApiWorktaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask',
    ...options
});

export const postApiWorktask = <ThrowOnError extends boolean = false>(options?: Options<PostApiWorktaskData, ThrowOnError>) => (options?.client ?? client).post<PostApiWorktaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiWorktaskMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetApiWorktaskMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetApiWorktaskMetadataResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/worktask/metadata',
    ...options
});

export const getWorkerschedulerWorkerschedulerGetworkers = <ThrowOnError extends boolean = false>(options?: Options<GetWorkerschedulerWorkerschedulerGetworkersData, ThrowOnError>) => (options?.client ?? client).get<GetWorkerschedulerWorkerschedulerGetworkersResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/workerscheduler/workerscheduler/getworkers',
    ...options
});

export const patchWorkerschedulerWorkerschedulerEnableforcenextrunById = <ThrowOnError extends boolean = false>(options: Options<PatchWorkerschedulerWorkerschedulerEnableforcenextrunByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchWorkerschedulerWorkerschedulerEnableforcenextrunByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/workerscheduler/workerscheduler/enableforcenextrun/{id}',
    ...options
});

export const getWorkerschedulerWorkerschedulerGetworkerwitherrorlogsbyidById = <ThrowOnError extends boolean = false>(options: Options<GetWorkerschedulerWorkerschedulerGetworkerwitherrorlogsbyidByIdData, ThrowOnError>) => (options.client ?? client).get<GetWorkerschedulerWorkerschedulerGetworkerwitherrorlogsbyidByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/workerscheduler/workerscheduler/getworkerwitherrorlogsbyid/{id}',
    ...options
});
